import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

const { Paragraph } = Typography;

const Notes = styled(Paragraph)`
  font-size: 12px;
  white-space: break-spaces;
`;

const EllipsisSymbol = styled.span`
  color: var(--dark-blue);
  cursor: pointer;
`;

type Props = {
  notes: string;
  dataTestId?: string;
};

const CMASummaryTableDataCommunityNotes = ({ notes, dataTestId }: Props) => (
  <Notes
    ellipsis={{
      rows: 5,
      expandable: 'collapsible',
      symbol: (expanded: boolean) => <EllipsisSymbol>{expanded ? 'Read Less' : 'Read More'}</EllipsisSymbol>,
    }}
    data-test-id={dataTestId}
  >
    {notes}
  </Notes>
);

export default CMASummaryTableDataCommunityNotes;
